<form [formGroup]="form" autocomplete="off">
  <div
    autocomplete="off"
    @fade
    formArrayName="enderecos"
    *ngFor="let endereco of enderecoList.controls; let index = index;"
    class="col-12"
  >
    <div class="row">
      <!-- cep -->
      <viggo-core-custom-input
        #cep
        class="field-cep"
        [placeholder]="!notRequired ? 'CEP *' : 'CEP'"
        class="col-md-4"
        [value]="enderecoList.controls[index].get('cep').value | cep"
        (blur)="checkCep($event.target.value, index)"
        [control]="enderecoList.controls[index].get('cep')"
        [readonly]="notRequired"
        [error]="
          readonly ?
            '' :
            displayMessage[index] && enderecoList.controls[index].get('cep').invalid ?
              displayMessage[index].cep :
              ''
        "
      ></viggo-core-custom-input>

      <!-- auto complete para municipio
        [classStyle]="'input-filters'"
      -->
      <viggo-core-autocomplete
        class="field-municipio mt-2 col-md-8"
        [inputClass]="'input-filters'"
        placeholder="Município"
        [useToSearch]="false"
        displayField="nome"
        [messages]="
          readonly ?
            '' :
            displayMessage[index] && enderecoList.controls[index].get('municipio').invalid ?
              {
                required: 'O municipio é obrigatório.',
                typeIs: 'Valor inválido'
              }
            : ''"
        #municipio
        [displayWithEntityFn]="displayFn"
        [entityService]="municipioService"
        [control]="enderecoList.controls[index].get('municipio')"
        [domain_id]="domain_id"
        [readonly]="true"
      >
      </viggo-core-autocomplete>

      <!-- campo de logradouro -->
      <viggo-core-custom-input
        #logradouro
        class="field-logradouro col-md-10"
        [readonly]="notRequired"
        [placeholder]="!notRequired ? 'Logradouro *' : 'Logradouro'"
        [control]="enderecoList.controls[index].get('logradouro')"
        [error]="readonly ? '' :
          displayMessage[index] && enderecoList.controls[index].get('logradouro').invalid ?
            displayMessage[index].logradouro : ''
        "
      ></viggo-core-custom-input>

      <!-- campo de numero -->
      <viggo-core-custom-input
        #numero
        class="field-numero"
        [placeholder]="!notRequired ? 'Nº *' : 'Nº'"
        class="field-logradouro col-md-2"
        [readonly]="notRequired"
        [control]="enderecoList.controls[index].get('numero')"
        [error]="readonly ? '' :
          displayMessage[index] && enderecoList.controls[index].get('numero').invalid ?
            displayMessage[index].numero : ''
        "
      ></viggo-core-custom-input>

      <!-- campo de complemento -->
      <viggo-core-custom-input
        #complemento
        class="field-complemento col-md-6"
        placeholder="Complemento"
        [readonly]="notRequired"
        [error]="readonly ? '' :
          displayMessage[index] && enderecoList.controls[index].get('complemento').invalid ?
            displayMessage[index].complemento : ''
        "
        [control]="enderecoList.controls[index].get('complemento')"
      ></viggo-core-custom-input>

      <!-- campo de bairro -->
      <viggo-core-custom-input
        #bairro
        class="field-bairro col-md-6"
        [placeholder]="!notRequired ? 'Bairro *' : 'Bairro'"
        [readonly]="notRequired"
        [error]="readonly ? '' :
          displayMessage[index] && enderecoList.controls[index].get('bairro').invalid
            ? displayMessage[index].bairro
            : ''
        "
        [control]="enderecoList.controls[index].get('bairro')"
      ></viggo-core-custom-input>

      <!-- campo de ponto de referencia  -->

      <div class="col-md-12 mt-3 field-ponto-referencia">
        <span class="p-float-label">
          <textarea
            rows="8"
            cols="100"
            pInputTextarea
            style="resize: none;"
            [readonly]="notRequired"
            id="inputtext-descricao"
            placeholder="Ex. vizinho a Daminhão..."
            [formControl]="enderecoList.controls[index].get('ponto_referencia')"
            class="input-filters-text-area"
          ></textarea>
          <label for="inputtext-descricao">Ponto de referência</label>
        </span>
        <small
          class="p-error"
          *ngIf="displayMessage[index] && displayMessage[index].ponto_referencia && !readonly && enderecoList.controls[index].get('ponto_referencia').invalid"
        >
          {{displayMessage[index].ponto_referencia}}
        </small>
      </div>
    </div>
  </div>
  <!-- control buttons -->
  <div class="w-100 d-flex justify-content-between">
    <button
      mat-stroked-button
      color="primary"
      matStepperPrevious
      (click)="changeStep()"
      id="previous-btn"
    >
      Voltar
    </button>
    <button
      *ngIf="!blocked_actions"
      id="next-btn"
      mat-flat-button
      color="primary"
      [disabled]="!form.valid"
      matStepperNext
      (click)="changeStep()"
    >
      Próximo
    </button>
    <button
      *ngIf="blocked_actions"
      id="next-btn"
      mat-flat-button
      color="primary"
      matStepperNext
      (click)="changeStep()"
    >
      Próximo
    </button>
  </div>
</form>
